export default __webpack_public_path__ + "static/mgodfrey-74c9d56f45093d9a16a1e7777d46faa5.png";